import { StaticDatePicker, PickersDay } from "@mui/x-date-pickers";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

const statusBg = {
  PRESENT:  "#c8e6c9", // light green
  LATE:     "#fce4c0ff", // orange
  LEAVE:    "#bbdefb", // blue
  ABSENT:   "#ecf1fdff", // red
  HOLIDAY:  "#ffa8b1ff", // gray
  PENDING:  "#fce3038c", // 🟡 light yellow (CORRECT)
};

export function CustomDay(props) {
  const { day, outsideCurrentMonth, data, ...other } = props;

  const record = data?.find(d =>
    dayjs(d.attendDate).isSame(day, "day")
  );

  const bgColor = record ? statusBg[record.status] : "transparent";

  return (
    <PickersDay
      {...other}
      day={day}
      outsideCurrentMonth={outsideCurrentMonth}
      sx={{
        backgroundColor: bgColor,
        "&:hover": {
          backgroundColor: bgColor,
        },
      }}
    />
  );
}


export default function AttendanceCalendar({ data = [], onSelect }) {
  return (
    <Box
      sx={{
        width: "55vw",
        height: "55vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          transform: "scale(1.5)",
          transformOrigin: "center",
        }}
      >
        <StaticDatePicker
          // value={dayjs()}
          onChange={onSelect}
          sx={{
            "& .MuiPickersToolbar-root": {
              display: "none",
            },
          }}
          slots={{
            day: CustomDay,
            actionBar: () => null,
          }}
          slotProps={{
            day: {
              data
            }
          }}
        />
      </Box>
    </Box>
  );
}
